import { creatorEconomyApi } from '../utils'
import { socialApiRequest } from './apiWrapper'

export async function fetchTopCreatorList(offset = 0, limit = 10) {
    const response = await socialApiRequest({
        method: 'get',
        url: '/feed/top_creators',
        params: {
            offset,
            limit
        }
    })
    return response
}

export async function fetchCreatorEconomyData(offset = 0, limit = 10, optionalParams = {}) {
    try {
        const response = await creatorEconomyApi({
            method: 'get',
            url: '/templates/',
            params: {
                offset,
                limit,
                ...optionalParams
            }
        })
        return response
    } catch (error) {
        if (error.response) {
            throw new Error(
                error.response.data?.error?.message || 'Unknown error'
            )
        }
        throw error
    }
}

export async function fetchTopCreatorDetails(creatorId) {
    const response = await apiRequest({
        method: 'get',
        url: `/topcreators/${creatorId}/`
    })
    return response
}
